import { render, staticRenderFns } from "./v002_itemList.vue?vue&type=template&id=7c81caec&"
import script from "./v002_itemList.vue?vue&type=script&lang=js&"
export * from "./v002_itemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports